export default "__VITE_ASSET__D7c4OnVk__"